import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';

import { getFixedPageStaticProps } from '@/lib/commonPageStaticProps';
import { SeoConfigBuilder } from '@/lib/seo/SeoVariables';
import { MyWatchesView } from '@/views/MyWatchesView';

export const getServerSideProps: GetServerSideProps = getFixedPageStaticProps(
  'my-account/my-watches',
  new SeoConfigBuilder().setNoIndex().build(),
);

export default withFixedPageCommonProps(MyWatchesView);
